'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCollapse = undefined;

var _is = require('ramda/src/is');

var _is2 = _interopRequireDefault(_is);

var _isNil = require('ramda/src/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _reject = require('ramda/src/reject');

var _reject2 = _interopRequireDefault(_reject);

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var compositionChain = function compositionChain(isOpenDry) {
  return (0, _reject2.default)(_isNil2.default)([isOpenDry ? null : (0, _recompose.withState)('isOpen', 'setOpen', function (props) {
    return !!props.isOpen;
  }), (0, _recompose.withHandlers)({
    onChangeIsOpen: function onChangeIsOpen(_ref) {
      var setOpen = _ref.setOpen,
          changeIsOpen = _ref.changeIsOpen,
          isOpen = _ref.isOpen;
      return function (event) {
        event.preventDefault();
        if (isOpenDry) return changeIsOpen(); // cannot have dry without handler
        setOpen(function (isOpen) {
          if ((0, _is2.default)(Function, changeIsOpen)) changeIsOpen(!isOpen);
          return !isOpen;
        });
      };
    }
  })]);
};

var withCollapse = exports.withCollapse = function withCollapse(isOpenDry) {
  return function (Component) {
    return _recompose.compose.apply(undefined, _toConsumableArray(compositionChain(isOpenDry)))(Component);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/logic/with-collapse.js
// module id = 2042
// module chunks = 0